module.exports = __webpack_public_path__ + "static/media/worldwide.8166ed92.svg";